"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = undefined;

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Text = require("../Text");

var _Text2 = _interopRequireDefault(_Text);

var _themed = require("../../utils/themed");

var _themed2 = _interopRequireDefault(_themed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Heading = exports.Heading = (0, _styledComponents2.default)(_Text2.default).withConfig({
  displayName: "Heading",
  componentId: "uepo8e-0"
})(["", ""], (0, _themed2.default)("Heading"));

Heading.defaultProps = {
  fontFamily: "Uni Neue Heavy",
  as: "h2",
  m: 0,
  fontSize: 4,
  fontWeight: "bold"
};

/** @component */
exports.default = Heading;